import createApi from 'api/createApi';

export const tags = {
	maps__group: 'mw/maps/group',
	maps__templates: 'mw/maps/templates',
	maps__folders__tree: 'mw/maps/folders-tree',
	maps__cartograms: 'mw/maps/cartograms',
	postmaps__cartograms: 'mw/maps/postmaps__cartograms',
	putmaps__cartograms: 'mw/maps/putmaps__cartograms',
	mw__maps__cartograms__upload__file: 'mw/maps/cartograms/upload-file',
	delete__maps__cartograms: 'mw/maps/delete__maps__cartograms',
	post__maps__group: 'mw/maps/post__maps__group',
	put__maps__group: 'mw/maps/put__maps__group',
	delete__maps__group: 'mw/maps/delete__maps__group',
};

export const mapsApi = createApi({
	reducerPath: 'mw/mapsApi',
	endpoints: (builder) => ({

		/**
		 * List of folders with charts, tree structure
		 */
		getFoldersTree: builder.query({
			query: () => ({
				method: 'GET',
				url: '/mw/maps/folders-tree',
			}),
			providesTags: [tags.maps__folders__tree],
		}),
		getCartogramId: builder.query({
			query: ({ id }) => ({
				method: 'GET',
				url: `/mw/maps/cartograms/${id}`,
			}),
			providesTags: [tags.maps__cartograms],
		}),
		getTemplates: builder.query({
			query: () => ({
				method: 'GET',
				url: '/mw/maps/templates',
			}),
			providesTags: [tags.maps__templates],
		}),
		getTemplateId: builder.query({
			query: ({ id }) => ({
				method: 'GET',
				url: `/mw/maps/templates/${id}`,
			}),
		}),

		/**
		 * Create group
		 * @param {string} name
		 * @param {number} parentId
		 */
		postMapGroup: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/maps/groups',
				body,
			}),
			providesTags: [tags.post__maps__group],
			invalidatesTags: [tags.maps__folders__tree],
		}),

		/**
		 * Update group
		 * @param {number} id
		 */
		putMapGroup: builder.mutation({
			query: ({ id, ...body }) => ({
				method: 'PUT',
				url: `/mw/maps/groups/${id}`,
				body,
			}),
			providesTags: [tags.put__maps__group],
			invalidatesTags: [tags.maps__folders__tree],
		}),

		/**
		 * Delete group
		 * @param {number} id
		 */
		deleteMapGroup: builder.mutation({
			query: ({ id }) => ({
				method: 'DELETE',
				url: `/mw/maps/groups/${id}`,
			}),
			providesTags: [tags.delete__maps__group],
			invalidatesTags: [tags.maps__folders__tree],
		}),

		/**
		 * @param {number} template_id
		 * @param {object} file
		 */
		postCartogramsFile: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/maps/cartograms/upload-file',
				body,
				formData: true,
				contentType: 'multipart/form-data',
			}),
		}),

		/**
		 * Create cartogram
		 * @param {string} name
		 * @param {number} templateId
		 * @param {number} groupId
		 * @param {array} points
		 */
		postCartograms: builder.mutation({
			query: (body) => ({
				method: 'POST',
				url: '/mw/maps/cartograms',
				body,
			}),
			providesTags: [tags.postmaps__cartograms],
			invalidatesTags: [tags.maps__folders__tree],
		}),

		/**
		 * Update cartogram
		 * @param {string} name
		 * @param {number} templateId
		 * @param {number} groupId
		 * @param {array} points
		 */
		putCartogramId: builder.mutation({
			query: ({ id, ...body }) => ({
				method: 'PUT',
				url: `/mw/maps/cartograms/${id}`,
				body,
			}),
			providesTags: [tags.putmaps__cartograms],
			invalidatesTags: [tags.maps__cartograms],
		}),
		deleteCartogramId: builder.mutation({
			query: ({ id }) => ({
				method: 'DELETE',
				url: `/mw/maps/cartograms/${id}`,
			}),
			providesTags: [tags.delete__maps__cartograms],
			invalidatesTags: [tags.maps__folders__tree],
		}),
	}),
});

export const {
	postMapGroup,
	putMapGroup,
	deleteMapGroup,
	getTemplates,
	getTemplateId,
	getFoldersTree,
	getCartogramId,
	postCartogramsFile,
	postCartograms,
	putCartogramId,
	deleteCartogramId,
} = mapsApi.endpoints;

export default mapsApi;
